import React, { useEffect } from "react";
import "../styles/SportsID.css"; 

const SportsID = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;

  return (
    <div className="sports-id-page">
  
  <div className="sports-id-header">
    <h1><span className="highlight">Reddy Anna's</span> Sports ID – Your Sports Betting Hub</h1>
    <p>Welcome to Reddy Anna's Sports ID, where passion for sports meets the thrill of online betting. From cricket to kabaddi, we bring the most exciting events to your fingertips. Get ready to explore your favorite sports, stay updated, and dive into an exhilarating world of sports betting.</p>
  </div>
  
  {/* Sports ID Section */}
  <div className="sports-id-section">
    {/* Cricket Card */}
    <div className="sports-id-card">
      <h2 className="sports-id-card-title">Cricket</h2>
      <p>
        Cricket is a global passion, and with Reddy Anna's Sports ID, you can experience the excitement of every match. From IPL to international test series, get live updates, player stats, and exclusive insights that fuel your cricket obsession.
      </p>
      <a
        href={ContactLink}
        target="_blank"
        rel="noopener noreferrer"
        className="sports-btn contactus-button"
      >
        Reach Us @7777857777
      </a>
    </div>

    {/* Football Card */}
    <div className="sports-id-card">
      <h2 className="sports-id-card-title">Football</h2>
      <p>
        Football, the world’s most loved sport, brings together millions of fans across the globe. Follow your favorite teams, stay updated on match predictions, player transfers, and insider news with Reddy Anna's Sports ID. Dive into football action like never before.
      </p>
      <a
        href={ContactLink}
        target="_blank"
        rel="noopener noreferrer"
        className="sports-btn contactus-button"
      >
        Reach Us @7777857777
      </a>
    </div>

    {/* Tennis Card */}
    <div className="sports-id-card">
      <h2 className="sports-id-card-title">Tennis</h2>
      <p>
        Tennis is a game of intense rivalries, precision, and finesse. Stay ahead with Reddy Anna's Sports ID by following major tournaments, including Wimbledon and the US Open, and get expert analysis, player stats, and match previews to elevate your tennis experience.
      </p>
      <a
        href={ContactLink}
        target="_blank"
        rel="noopener noreferrer"
        className="sports-btn contactus-button"
      >
        Reach Us @7777857777
      </a>
    </div>

    {/* Horse Racing Card */}
    <div className="sports-id-card">
      <h2 className="sports-id-card-title">Horse Racing</h2>
      <p>
        Experience the excitement of horse racing, with its blend of strategy and speed. From legendary events like the Kentucky Derby to international championships, Reddy Anna's Sports ID brings you the latest race previews, betting tips, and results to keep you in the loop.
      </p>
      <a
        href={ContactLink}
        target="_blank"
        rel="noopener noreferrer"
        className="sports-btn contactus-button"
      >
        Reach Us @7777857777
      </a>
    </div>

    {/* Kabaddi Card */}
    <div className="sports-id-card">
      <h2 className="sports-id-card-title">Kabaddi</h2>
      <p>
        Kabaddi has taken the world by storm with its fast-paced and intense gameplay. From the Pro Kabaddi League to international events, Reddy Anna's Sports ID ensures you never miss out on the action. Get match highlights, player updates, and expert analysis for all things kabaddi.
      </p>
      <a
        href={ContactLink}
        target="_blank"
        rel="noopener noreferrer"
        className="sports-btn contactus-button"
      >
        Reach Us @7777857777
      </a>
    </div>
  </div>

  {/* Call-to-Action Section */}
  <div className="sports-id-cta">
    <h2 className="cta-title"><span className="highlight">Reddy Anna's</span> Sports ID – Your Betting Gateway</h2>
    <p>
      Whether you're a fan of cricket, football, tennis, or any other sport, Reddy Anna's Sports ID connects you with all the action. Stay informed, place your bets, and experience the thrill of live sports betting with us.
    </p>
    <div className="sports-bttn">
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="contactus-button"
      >
        WhatsApp Us @7777857777
      </a>
    </div>
  </div>
</div>
  );
};

export default SportsID;
